module.exports = __webpack_public_path__ + "static/media/single-degrees.ae64f5bc.jpg";